import { NoSsr } from "@mui/material";
import * as Sentry from "@sentry/nextjs";

import { ExternalWidgetBokunContent } from "../../components/ExternalWidget/ExternalWidgetBokunContent";
import { ExternalWidgetBookingkitContent } from "../../components/ExternalWidget/ExternalWidgetBookingkitContent";
import { ExternalWidgetFareharborContent } from "../../components/ExternalWidget/ExternalWidgetFareharborContent";
import { ExternalWidgetPeekContent } from "../../components/ExternalWidget/ExternalWidgetPeekContent";
import { ExternalWidgetRezdy } from "../../components/ExternalWidget/ExternalWidgetRezdy";
import { ExternalWidgetTicketinghubContent } from "../../components/ExternalWidget/ExternalWidgetTicketinghubContent";
import { ExternalWidgetTravelotoposContent } from "../../components/ExternalWidget/ExternalWidgetTravelotoposContent";
import { ExternalWidgetVentrataContent } from "../../components/ExternalWidget/ExternalWidgetVentrataContent";
import { ExternalWidgetXolaContent } from "../../components/ExternalWidget/ExternalWidgetXolaContent";
import { ExternalWidget } from "../../types/ExternalWidget";
import { objectWithoutTypename } from "../../utils/objectWithoutTypename";

export type AvailabilityExternalWidgetContentProps = {
    widget: ExternalWidget;
    open: boolean;
    onClose: () => void;
};

export function AvailabilityExternalWidgetContent({ widget, open, onClose }: AvailabilityExternalWidgetContentProps) {
    let content = null;

    if (widget.__typename === "ExternalWidgetRezdy") {
        content = <ExternalWidgetRezdy {...objectWithoutTypename(widget)} />;
    } else if (widget.__typename === "ExternalWidgetBokun") {
        content = <ExternalWidgetBokunContent {...objectWithoutTypename(widget)} />;
    } else if (widget.__typename === "ExternalWidgetXola") {
        content = <ExternalWidgetXolaContent />;
    } else if (widget.__typename === "ExternalWidgetFareharbor") {
        content = <ExternalWidgetFareharborContent {...objectWithoutTypename(widget)} />;
    } else if (widget.__typename === "ExternalWidgetPeek") {
        content = <ExternalWidgetPeekContent />;
    } else if (widget.__typename === "ExternalWidgetTicketinghub") {
        content = (
            <ExternalWidgetTicketinghubContent {...objectWithoutTypename(widget)} open={open} onClose={onClose} />
        );
    } else if (widget.__typename === "ExternalWidgetBookingkit") {
        content = <ExternalWidgetBookingkitContent {...objectWithoutTypename(widget)} open={open} onClose={onClose} />;
        if (!widget.subdomain) {
            Sentry.withScope((scope) => {
                scope.setTag("product", "externalWidget");
                Sentry.captureException(new Error("No EntityConfiguration for ExternalWidgetBookingkit"));
            });
        }
    } else if (widget.__typename === "ExternalWidgetTravelotopos") {
        content = <ExternalWidgetTravelotoposContent {...objectWithoutTypename(widget)} />;
        if (!widget.subdomain) {
            Sentry.withScope((scope) => {
                scope.setTag("product", "externalWidget");
                Sentry.captureException(new Error("No EntityConfiguration for ExternalWidgetTravelotopos"));
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    } else if (widget.__typename === "ExternalWidgetVentrata") {
        content = <ExternalWidgetVentrataContent {...objectWithoutTypename(widget)} />;
        if (!widget.apiKey) {
            Sentry.withScope((scope) => {
                scope.setTag("product", "externalWidget");
                Sentry.captureException(new Error("No EntityConfiguration for ExternalWidgetVentrata"));
            });
        }
    }

    return <NoSsr>{content}</NoSsr>;
}
